export default "__VITE_ASSET__DMPyYyzd__"